export const dispatchFavoriteAddedEvent = (tripId: string) => {
  document.dispatchEvent(
    new CustomEvent('favoriteChanged', { detail: { tripId, action: 'add' } }),
  );
};

export const dispatchFavoriteRemovedEvent = (tripId: string) => {
  document.dispatchEvent(
    new CustomEvent('favoriteChanged', { detail: { tripId, action: 'remove' } }),
  );
};
